import * as React from "react";
import { LineChart, Line, ResponsiveContainer, Legend, XAxis, YAxis, Tooltip } from "recharts";

import moment = require("moment");

import { MonthlyOhCaseCount } from "../model";

interface Props {
    monthlyOhCaseCounts: MonthlyOhCaseCount[];
}

export const OhCasesGraph: React.FC<Props> = (props: Props) => {
    const data = props.monthlyOhCaseCounts.map(c => ({
        date: moment({ year: c.year, month: c.month - 1 }).format("MMM YYYY"),
        referrals: c.referrals,
        ppqs: c.ppqs
    }));
    return (
        <ResponsiveContainer aspect={2}>
            <LineChart data={data}>
                <Line type="monotone" dataKey="referrals" stroke="#f39200" name="Referral" />
                <Line type="monotone" dataKey="ppqs" stroke="#258939" name="PPQ" />
                <Legend layout="vertical" verticalAlign="middle" align="right" />
                <XAxis dataKey="date" />
                <YAxis type="number" allowDecimals={false} />
                <Tooltip />
            </LineChart>
        </ResponsiveContainer>
    );
};
